import { makeStyles } from '@material-ui/core/styles'
import { BREAKPOINTS, COLORS } from '../../../constants'

export const styles = makeStyles(() => ({
  badge: {
    display: 'inline-block',
    padding: '2px 8px',
    borderRadius: 2,
    background: COLORS.lightBlack,
    color: COLORS.white,
    fontSize: 10,
    lineHeight: 1.6,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    userSelect: 'none',
    whiteSpace: 'nowrap',
    [`@media (min-width: ${BREAKPOINTS.md}px)`]: {
      fontSize: 11,
    },
  },
}))
